export default {
  name: "SearchElement",
  props: {
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    value: {
      type: String,
      default: "",
      required: false
    }
  },
  methods: {
    onInput(event) {
      if (this.disabled || !event.target.checkValidity()) return;
      const value = event.target.value.split(",").filter(v => !!v).map(element => element.trim());
      this.$emit("search", {
        value
      });
    }
  }
};